export interface Article {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  categoryName: string;
  type: "news" | "video" | "report";
  tags: string[];
  author: string;
  publishTime: string;
  views: number;
  likes: number;
  content: string[];
  gallery: string[];
}

export const articles: Article[] = [
  {
    id: "star-01",
    title: "顶流男星被拍到深夜同框神秘女子，双方工作室暂未回应",
    summary:
      "有网友爆料在某商圈餐厅偶遇一位顶流男星与神秘女子共进晚餐，两人一路并肩离开，照片发布后迅速登上热搜，相关话题阅读量破十亿。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20city%20night%20street%20scene%20with%20warm%20neon%20lights%2C%20cinematic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20news%20photography%2C%20soft%20warm%20tones%2C%20clean%20composition&width=800&height=600&seq=chigua-star-01-cover&orientation=landscape",
    category: "star",
    categoryName: "明星动态",
    type: "news",
    tags: ["恋情曝光", "热搜", "顶流男星"],
    author: "吃瓜小分队",
    publishTime: "2026-10-12T22:14:00+08:00",
    views: 128400,
    likes: 9820,
    content: [
      "昨晚，有网友在社交平台晒出一组照片，称在某商圈的高层餐厅偶遇一位顶流男星。照片中，该男星身穿深色外套、戴着棒球帽，与一名同样低调打扮的女子并肩用餐，气氛看起来相当轻松自然。",
      "据现场网友描述，两人用餐时间接近两个小时，离开时一前一后走出餐厅，随后搭乘同一辆车离开。该组照片发布后仅半小时，相关话题便冲上热搜榜前列，讨论量迅速攀升。",
      "截至发稿前，男星所属工作室与该女子的身份均未得到官方确认，双方也暂未对传闻作出任何回应。不少粉丝在评论区表示希望理性吃瓜，不要过度打扰当事人的私生活。",
      "事实上，近段时间该男星正在为新作品进行密集宣传，行程排得相当满。有业内人士分析，此次同框或许与工作合作有关，具体情况仍有待当事人进一步说明。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=cozy%20upscale%20restaurant%20interior%20in%20the%20evening%20with%20warm%20ambient%20lighting%2C%20elegant%20modern%20decor%2C%20soft%20bokeh%20background%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=chigua-star-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=blurred%20city%20street%20at%20night%20with%20glowing%20signs%20and%20passing%20cars%2C%20cinematic%20mood%2C%20soft%20warm%20highlights%2C%20shallow%20depth%20of%20field%2C%20artistic%20urban%20photography&width=1200&height=800&seq=chigua-star-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "star-02",
    title: "女演员片场路透曝光，素颜状态引发网友热议",
    summary:
      "一组剧组片场路透照在网络流传，该女演员几乎素颜出镜，状态与精修图差别明显，网友围绕艺人真实状态与修图话题展开讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20set%20behind%20the%20scenes%20with%20soft%20daylight%2C%20camera%20equipment%20and%20warm%20bokeh%2C%20documentary%20style%20photography%2C%20natural%20warm%20tones%2C%20clean%20minimal%20composition&width=800&height=600&seq=chigua-star-02-cover&orientation=landscape",
    category: "star",
    categoryName: "明星动态",
    type: "news",
    tags: ["行程路透", "素颜", "片场"],
    author: "娱记阿柴",
    publishTime: "2026-10-12T15:40:00+08:00",
    views: 76300,
    likes: 4120,
    content: [
      "近日，一组来自某剧组的片场路透照在网络上流传开来。照片中的女演员几乎以素颜状态出现，头发随意扎起，穿着剧组的日常服装，与平日红毯上精致的造型形成明显反差。",
      "照片曝光后，网友的态度呈现两极：一部分人认为素颜状态下的真实感十分亲切，反而更有生活气息；另一部分人则围绕艺人真实状态与团队修图的话题展开讨论。",
      "有剧组工作人员透露，当天拍摄的是一场清晨的戏，演员凌晨便已到场化妆准备，长时间拍摄后状态自然会有起伏。工作人员也呼吁大家多关注作品本身。",
      "事实上，越来越多的艺人开始主动分享自己的真实状态，试图拉近与观众的距离。这背后折射出的是大众审美与娱乐行业心态的悄然变化。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=movie%20production%20set%20with%20soft%20morning%20light%2C%20film%20cameras%20and%20lighting%20rigs%2C%20warm%20neutral%20tones%2C%20documentary%20photography%2C%20clean%20composition%2C%20shallow%20depth&width=1200&height=800&seq=chigua-star-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=backstage%20dressing%20room%20with%20vanity%20mirror%20lights%2C%20wardrobe%20racks%20and%20props%2C%20warm%20ambient%20glow%2C%20editorial%20interior%20photography%2C%20soft%20shadows&width=1200&height=800&seq=chigua-star-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "film-01",
    title: "年度科幻巨制口碑两极分化，特效惊艳但剧情遭吐槽",
    summary:
      "备受期待的年度科幻大片正式上映，视觉特效获得一致好评，但剧情逻辑与人物塑造引发争议，评分一路走低，成为近期讨论度最高的影片。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20cityscape%20with%20glowing%20orange%20and%20amber%20lights%2C%20futuristic%20architecture%2C%20epic%20atmosphere%2C%20dramatic%20lighting%2C%20film%20poster%20style%2C%20high%20detail&width=800&height=600&seq=chigua-film-01-cover&orientation=landscape",
    category: "film",
    categoryName: "影视评论",
    type: "report",
    tags: ["院线电影", "科幻", "口碑争议"],
    author: "影评人老周",
    publishTime: "2026-10-11T19:05:00+08:00",
    views: 156800,
    likes: 7340,
    content: [
      "作为本年度最受瞩目的科幻巨制，这部影片从立项之初便自带光环。上映首日，其视觉特效确实没有让观众失望，宏大的城市景观与细腻的机械设定令人印象深刻。",
      "然而，随着观影人数增加，影片的口碑开始出现明显分化。不少观众指出，影片在剧情推进上存在较多跳跃，人物动机的铺垫略显单薄，导致情感高潮难以真正打动人心。",
      "也有影迷持不同看法，认为这类作品本就以视听体验为核心，剧情上的留白恰恰给了观众想象空间，不必用传统叙事标准去苛求。",
      "截至目前，影片在多个平台的评分仍在波动。无论如何，它已经成为近期讨论度最高的作品之一，也让行业再次思考商业大片在视觉与叙事之间如何取得平衡。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20control%20room%20with%20holographic%20screens%2C%20warm%20orange%20accent%20lighting%2C%20cinematic%20atmosphere%2C%20high%20detail%2C%20dramatic%20shadows&width=1200&height=800&seq=chigua-film-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=empty%20modern%20movie%20theater%20with%20rows%20of%20seats%20and%20glowing%20screen%2C%20warm%20ambient%20lights%2C%20cinematic%20photography%2C%20moody%20atmosphere%2C%20soft%20shadows&width=1200&height=800&seq=chigua-film-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "film-02",
    title: "小成本现实题材电影逆袭，票房破十亿成年度黑马",
    summary:
      "一部没有流量明星、制作成本有限的现实题材电影凭借口碑发酵实现长线逆袭，票房突破十亿，成为今年最令人惊喜的行业案例。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20sunlit%20small%20town%20street%20scene%2C%20everyday%20life%20atmosphere%2C%20soft%20golden%20hour%20light%2C%20documentary%20style%20photography%2C%20natural%20warm%20tones%2C%20clean%20composition&width=800&height=600&seq=chigua-film-02-cover&orientation=landscape",
    category: "film",
    categoryName: "影视评论",
    type: "report",
    tags: ["票房黑马", "现实题材", "口碑"],
    author: "影评人老周",
    publishTime: "2026-10-10T11:20:00+08:00",
    views: 98400,
    likes: 6210,
    content: [
      "在流量与特效主导的市场里，这部小成本现实题材电影的出现显得格外特别。它没有大牌阵容，也没有铺天盖地的宣传，靠的只是观众口口相传的好评。",
      "影片以普通人的日常生活为切入点，用细腻的镜头语言讲述了一个关于坚持与亲情的故事。许多观众表示，走出影院后依然久久不能平静。",
      "随着口碑持续发酵，影片上映后的排片占比不降反升，最终票房突破十亿。业内人士认为，这一案例再次证明，真诚的故事依然能够打动观众。",
      "导演在接受采访时坦言，拍摄过程中团队并不被看好，能够走到今天靠的是每一位主创的坚持。他希望大家能给予现实题材更多关注与耐心。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=nostalgic%20small%20town%20alley%20in%20soft%20afternoon%20light%2C%20warm%20earth%20tones%2C%20quiet%20everyday%20scene%2C%20documentary%20photography%2C%20gentle%20shadows&width=1200&height=800&seq=chigua-film-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=warm%20family%20dining%20table%20scene%20with%20simple%20home%20cooking%2C%20soft%20natural%20light%2C%20cozy%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=chigua-film-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "inf-01",
    title: "头部主播直播间销售额再破纪录，单场带货超五亿",
    summary:
      "某头部主播在年度大促首场直播中交出亮眼成绩单，单场成交额突破五亿，多款爆品开售后瞬间售罄，再次刷新行业纪录。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20live%20streaming%20studio%20with%20ring%20lights%20and%20camera%20setup%2C%20warm%20orange%20accent%20lighting%2C%20energetic%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=chigua-inf-01-cover&orientation=landscape",
    category: "influencer",
    categoryName: "网红热点",
    type: "news",
    tags: ["直播带货", "销售纪录", "大促"],
    author: "电商观察员",
    publishTime: "2026-10-11T09:30:00+08:00",
    views: 142300,
    likes: 8660,
    content: [
      "年度大促的第一场直播，这位头部主播再一次用数据证明了自己的号召力。开播不到一小时，直播间在线人数便突破百万，多款爆品上架即售罄。",
      "据直播间战报显示，本场直播累计成交额突破五亿元，客单价与转化率均创下年内新高。其中美妆与家居品类表现尤为突出，成为拉动销量的主力。",
      "为了这场直播，团队提前数月进行选品与筹备，从产品测试到价格谈判都经过了多轮打磨。主播在直播中多次强调，选品标准始终是把好产品带到观众面前。",
      "业内分析认为，大促期间的流量竞争愈发激烈，头部主播的优势正在从单纯的流量转向供应链与选品能力的综合比拼，这对整个行业而言未必不是一件好事。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=colorful%20product%20display%20shelves%20in%20a%20bright%20studio%2C%20various%20packaged%20goods%2C%20warm%20accent%20lighting%2C%20clean%20commercial%20photography%2C%20organized%20composition&width=1200&height=800&seq=chigua-inf-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=warehouse%20fulfillment%20center%20with%20packages%20on%20conveyor%20belts%2C%20warm%20industrial%20lighting%2C%20busy%20logistics%20scene%2C%20documentary%20photography%2C%20clean%20composition&width=1200&height=800&seq=chigua-inf-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "inf-02",
    title: "千万粉网红翻车事件持续发酵，多个品牌方紧急切割",
    summary:
      "某千万粉丝级别的网红因直播言论引发巨大争议，风波持续升温，多家合作品牌火速下架相关物料并宣布终止合作。",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20spotlight%20on%20an%20empty%20stage%2C%20moody%20dark%20background%20with%20warm%20orange%20glow%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=600&seq=chigua-inf-02-cover&orientation=landscape",
    category: "influencer",
    categoryName: "网红热点",
    type: "news",
    tags: ["争议翻车", "品牌解约", "风波"],
    author: "电商观察员",
    publishTime: "2026-10-09T20:10:00+08:00",
    views: 187500,
    likes: 11240,
    content: [
      "一场原本普通的直播，因为几句不当言论迅速演变成全网关注的风波。该网红在直播中的表述被网友认为缺乏对消费者的尊重，相关片段被大量转发。",
      "风波发酵后，多个此前与之合作的品牌迅速做出反应，陆续下架相关宣传物料，并在官方渠道发布声明宣布终止合作。部分品牌还表示将重新审视达人合作的筛选标准。",
      "面对舆论压力，该网红随后发布致歉声明，称自己言语失当，并承诺暂停直播进行反思。不过，不少网友对这一回应并不买账，认为道歉来得太迟。",
      "这起事件再次为内容创作者敲响警钟：流量可以带来收益，但公众人物更需要对自身言行负责。行业规范与自律，正在成为绕不开的话题。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=smartphone%20showing%20social%20media%20feed%20with%20warm%20lighting%2C%20close%20up%20of%20screen%2C%20moody%20background%2C%20editorial%20technology%20photography%2C%20clean%20composition&width=1200&height=800&seq=chigua-inf-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=empty%20brand%20billboard%20space%20on%20a%20city%20building%20at%20dusk%2C%20warm%20orange%20sky%2C%20cinematic%20urban%20photography%2C%20moody%20atmosphere%2C%20clean%20lines&width=1200&height=800&seq=chigua-inf-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "event-01",
    title: "年度颁奖礼红毯造型盘点，有人封神有人翻车",
    summary:
      "备受关注的年度颁奖礼如期举行，众星云集的红毯成为最大看点，造型盘点话题迅速刷屏，网友的评价褒贬不一。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20event%20venue%20with%20glowing%20spotlights%2C%20luxurious%20warm%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20editorial%20event%20photography%2C%20high%20detail&width=800&height=600&seq=chigua-event-01-cover&orientation=landscape",
    category: "event",
    categoryName: "热点事件",
    type: "video",
    tags: ["颁奖典礼", "红毯", "造型"],
    author: "时尚前线",
    publishTime: "2026-10-10T22:50:00+08:00",
    views: 210600,
    likes: 15320,
    content: [
      "一年一度的颁奖礼如期而至，而真正抢走风头的，依旧是那条铺满聚光灯的红毯。今年的红毯整体水平相当高，多位艺人的造型被网友称为封神之作。",
      "从高定礼服到定制珠宝，从复古港风到未来感剪裁，今年的造型风格跨度极大。其中几套以暖色调为主的设计尤其出彩，在灯光的映衬下格外醒目。",
      "当然，争议也从未缺席。个别造型被吐槽比例失调或配色突兀，相关讨论一度冲上热搜。不过也有网友认为，敢于尝试本身就是一种态度。",
      "红毯造型早已不只是穿衣服那么简单，它背后是造型团队、品牌资源与个人审美的综合呈现。一次成功的亮相，往往能带来远超预期的关注度。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=glamorous%20event%20stage%20with%20warm%20golden%20lighting%20and%20elegant%20drapes%2C%20luxurious%20atmosphere%2C%20cinematic%20photography%2C%20high%20detail%2C%20soft%20bokeh&width=1200&height=800&seq=chigua-event-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=photographers%20and%20cameras%20at%20an%20elegant%20event%20entrance%2C%20warm%20spotlights%2C%20busy%20glamorous%20scene%2C%20editorial%20photography%2C%20soft%20shadows&width=1200&height=800&seq=chigua-event-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "event-02",
    title: "综艺录制现场突发状况，节目组深夜发声明致歉",
    summary:
      "某热门综艺在录制过程中出现突发状况，现场一度暂停录制，节目组于深夜发布声明向嘉宾与观众致歉并说明后续安排。",
    cover:
      "https://readdy.ai/api/search-image?query=tv%20studio%20recording%20set%20with%20warm%20stage%20lighting%2C%20empty%20seats%20and%20equipment%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=chigua-event-02-cover&orientation=landscape",
    category: "event",
    categoryName: "热点事件",
    type: "news",
    tags: ["综艺录制", "声明", "突发热议"],
    author: "综艺观察",
    publishTime: "2026-10-08T23:40:00+08:00",
    views: 87900,
    likes: 5340,
    content: [
      "据现场观众透露，某热门综艺在录制过程中出现突发状况，录制一度暂停。为保障相关人员安全，节目组第一时间疏散了现场人员并调整了流程。",
      "事件在网络上引发关注后，节目组于深夜发布声明，向参与录制的嘉宾与守候的观众致歉，同时说明了当晚的具体情况与后续的安排。",
      "声明中提到，节目组已对现场流程进行全面复盘，并将在后续录制中加强各项保障措施，避免类似情况再次发生。",
      "目前，节目后续录制计划暂未受明显影响。多数网友对节目组的及时回应表示理解，也呼吁大家给创作者多一些包容与耐心。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=backstage%20studio%20corridor%20with%20warm%20directional%20lighting%2C%20equipment%20cases%20and%20cables%2C%20cinematic%20atmosphere%2C%20documentary%20photography%2C%20soft%20shadows&width=1200&height=800&seq=chigua-event-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=rows%20of%20empty%20audience%20seats%20in%20a%20warm%20lit%20studio%2C%20stage%20glow%20in%20the%20distance%2C%20cinematic%20photography%2C%20moody%20atmosphere%2C%20clean%20composition&width=1200&height=800&seq=chigua-event-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "var-01",
    title: "竞技类综艺新一季开播，赛制升级引发观众讨论",
    summary:
      "备受期待的竞技综艺新一季正式开播，本季对赛制进行了大幅升级，首期节目播出后口碑不俗，观众对后续赛程充满期待。",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20competition%20show%20stage%20with%20warm%20orange%20lighting%2C%20dramatic%20spotlights%2C%20vibrant%20atmosphere%2C%20cinematic%20photography%2C%20high%20detail&width=800&height=600&seq=chigua-var-01-cover&orientation=landscape",
    category: "variety",
    categoryName: "综艺节目",
    type: "video",
    tags: ["竞技综艺", "赛制升级", "首播"],
    author: "综艺观察",
    publishTime: "2026-10-07T21:15:00+08:00",
    views: 112400,
    likes: 7010,
    content: [
      "作为一档已经播出了数季的竞技综艺，本季最大的变化在于赛制的全面升级。节目组引入了全新的积分与淘汰机制，让比赛的悬念感大幅提升。",
      "首期节目播出后，观众对本季的赛制设计评价普遍积极。不少人表示，新规则让选手的每一轮表现都更加关键，观感上紧张感十足。",
      "嘉宾阵容方面，本季既有观众熟悉的老面孔，也加入了多位新鲜血液。新老选手之间的碰撞，成为节目的一大看点。",
      "节目组表示，赛制的调整是为了让比赛更加公平也更有观赏性。后续节目还将陆续解锁更多玩法，希望观众能够持续关注。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=bright%20tv%20game%20show%20set%20with%20colorful%20panels%20and%20stage%20lights%2C%20warm%20accent%20glow%2C%20playful%20energetic%20atmosphere%2C%20editorial%20photography%2C%20clean%20lines&width=1200&height=800&seq=chigua-var-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=audience%20cheering%20in%20a%20warm%20lit%20studio%2C%20blurred%20silhouettes%20and%20glowing%20stage%2C%20energetic%20atmosphere%2C%20cinematic%20photography%2C%20soft%20bokeh&width=1200&height=800&seq=chigua-var-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "var-02",
    title: "慢综艺回归田园，治愈系画风成周末解压首选",
    summary:
      "在快节奏的内容环境里，一档回归田园的慢综艺凭借治愈的画面与松弛的节奏收获好评，成为许多人周末解压的首选节目。",
    cover:
      "https://readdy.ai/api/search-image?query=peaceful%20countryside%20farmhouse%20with%20golden%20hour%20light%2C%20green%20fields%20and%20warm%20sky%2C%20serene%20healing%20atmosphere%2C%20editorial%20photography%2C%20soft%20natural%20tones&width=800&height=600&seq=chigua-var-02-cover&orientation=landscape",
    category: "variety",
    categoryName: "综艺节目",
    type: "video",
    tags: ["慢综艺", "治愈系", "田园"],
    author: "生活频道",
    publishTime: "2026-10-06T18:00:00+08:00",
    views: 65800,
    likes: 4390,
    content: [
      "当大多数综艺都在比拼节奏与刺激时，这档慢综艺却反其道而行之。节目把镜头对准田园生活，用一餐一饭、一草一木讲述最简单的美好。",
      "没有激烈的任务竞争，也没有刻意的戏剧冲突，嘉宾们只是安静地做饭、聊天、感受四季流转。正是这种松弛感，让许多观众直呼被治愈。",
      "节目标志性的暖色调画面也被网友反复截屏，成为社交平台上的热门壁纸。有观众评论说，看节目的时候整个人都放松了下来。",
      "在内容越来越卷的当下，慢综艺的走红或许正说明，观众需要的不仅是刺激，还有一种能够安放情绪的陪伴。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=rustic%20wooden%20table%20with%20fresh%20home%20cooked%20meal%20and%20vegetables%2C%20warm%20natural%20light%2C%20cozy%20farmhouse%20scene%2C%20editorial%20food%20photography%2C%20soft%20tones&width=1200&height=800&seq=chigua-var-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20countryside%20path%20at%20dusk%20with%20warm%20golden%20sky%2C%20trees%20and%20fields%2C%20peaceful%20healing%20atmosphere%2C%20documentary%20photography%2C%20soft%20light&width=1200&height=800&seq=chigua-var-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "music-01",
    title: "实力歌手全新专辑上线，主打歌首日登顶热歌榜",
    summary:
      "蛰伏两年后，这位实力歌手携全新专辑回归，主打歌上线首日便登顶多个音乐平台热歌榜，扎实的唱功再度获得认可。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20recording%20studio%20with%20warm%20amber%20lighting%2C%20microphone%20and%20mixing%20console%2C%20intimate%20musical%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=chigua-music-01-cover&orientation=landscape",
    category: "music",
    categoryName: "音乐现场",
    type: "news",
    tags: ["新歌发布", "专辑", "热歌榜"],
    author: "音乐盒子",
    publishTime: "2026-10-05T12:30:00+08:00",
    views: 93400,
    likes: 6720,
    content: [
      "暌违两年，这位以唱功著称的歌手终于带来了全新专辑。专辑共收录十首作品，风格横跨流行、民谣与爵士，展现了更加成熟的音乐表达。",
      "主打歌上线首日便登顶多个平台的热歌榜，评论区里满是听众的惊喜。有人说，久违的现场级唱功让人一听就起鸡皮疙瘩。",
      "据制作团队透露，这张专辑历时一年多打磨，从创作到编曲都经过了反复推敲。歌手本人也参与了大部分词曲创作，可以说是诚意十足。",
      "接下来，歌手将启动新一轮的巡演计划，把专辑中的作品带到更多城市的舞台上。对于期待已久的乐迷来说，这无疑是个好消息。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20vintage%20microphone%20in%20a%20warm%20lit%20studio%2C%20soft%20bokeh%20background%2C%20moody%20musical%20atmosphere%2C%20editorial%20photography%2C%20warm%20tones&width=1200&height=800&seq=chigua-music-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=musician%20playing%20acoustic%20guitar%20in%20a%20warm%20sunlit%20room%2C%20intimate%20atmosphere%2C%20soft%20natural%20light%2C%20documentary%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=chigua-music-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "music-02",
    title: "万人演唱会门票秒罄，粉丝应援方式登上热搜",
    summary:
      "某歌手万人规模演唱会开票即售罄，抢票热度超乎想象。与此同时，粉丝精心准备的应援方式也在网上引发热议，成为现场之外的焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=large%20concert%20arena%20filled%20with%20warm%20glowing%20lights%2C%20crowd%20silhouettes%20and%20stage%20glow%2C%20epic%20atmosphere%2C%20cinematic%20photography%2C%20high%20detail&width=800&height=600&seq=chigua-music-02-cover&orientation=landscape",
    category: "music",
    categoryName: "音乐现场",
    type: "video",
    tags: ["演唱会", "应援", "热搜"],
    author: "音乐盒子",
    publishTime: "2026-10-04T20:45:00+08:00",
    views: 108700,
    likes: 8130,
    content: [
      "开票当天，这场万人规模的演唱会门票在极短时间内被抢购一空，多个票档瞬间显示售罄，抢票页面一度被挤到卡顿。",
      "除了抢票本身，粉丝为演唱会准备的应援方式同样成为热点。从统一的应援色到精心设计的周边，粉丝们的用心程度让不少路人直呼佩服。",
      "主办方随后发文提醒观众通过官方渠道购票，警惕黄牛与假票风险，同时也表示将尽可能增加安可场次，让更多歌迷能够到现场。",
      "对于一场演唱会而言，舞台上的表演与舞台下的热情同样重要。这种双向奔赴的氛围，正是现场演出最动人的地方。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=sea%20of%20warm%20glowing%20lights%20held%20by%20a%20concert%20crowd%2C%20dark%20arena%20with%20stage%20glow%2C%20epic%20atmosphere%2C%20cinematic%20photography%2C%20soft%20bokeh&width=1200&height=800&seq=chigua-music-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=colorful%20fan%20merchandise%20and%20light%20sticks%20laid%20out%20on%20a%20table%2C%20warm%20lighting%2C%20clean%20flat%20lay%20photography%2C%20organized%20composition&width=1200&height=800&seq=chigua-music-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "fashion-01",
    title: "当红小花红毯高定造型出圈，造型师回应设计理念",
    summary:
      "某当红小花在红毯上的一身高定造型意外出圈，独特的设计感收获大量好评，造型师随后回应了背后的设计理念与搭配巧思。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20high%20fashion%20gown%20on%20a%20mannequin%20with%20warm%20spotlight%2C%20luxurious%20fabric%20texture%2C%20glamorous%20studio%20atmosphere%2C%20editorial%20fashion%20photography%2C%20high%20detail&width=800&height=600&seq=chigua-fashion-01-cover&orientation=landscape",
    category: "fashion",
    categoryName: "时尚穿搭",
    type: "report",
    tags: ["红毯造型", "高定", "时尚"],
    author: "时尚前线",
    publishTime: "2026-10-09T16:20:00+08:00",
    views: 79600,
    likes: 5820,
    content: [
      "在近期的一场活动中，这位当红小花以一袭高定礼服亮相，独特的设计与出色的气质让她成为当晚的焦点之一，相关图片迅速刷屏。",
      "这套造型最大的亮点在于剪裁与色彩的平衡，柔和的面料与暖色调相互映衬，既突出了身材比例，又不显浮夸，被网友称赞高级感十足。",
      "造型师在采访中透露，整套造型从选款到最终呈现历经多次调整，团队希望传达的是一种从容而自信的美，而非刻意博眼球。",
      "随着造型出圈，同款单品与相似风格的搜索量也明显上升。可见一次成功的红毯亮相，往往能带动一波不小的时尚热潮。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=luxurious%20fabric%20swatches%20in%20warm%20cream%20and%20amber%20tones%2C%20soft%20natural%20light%2C%20elegant%20textile%20flat%20lay%2C%20editorial%20photography%2C%20clean%20composition&width=1200&height=800&seq=chigua-fashion-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=delicate%20jewelry%20and%20accessories%20arranged%20on%20warm%20silk%20fabric%2C%20soft%20lighting%2C%20luxurious%20still%20life%2C%20editorial%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=chigua-fashion-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "fashion-02",
    title: "明星街拍秋冬穿搭指南，这几件单品正在流行",
    summary:
      "随着气温下降，明星们的秋冬街拍成为穿搭灵感来源。本期盘点几件正在流行的单品，帮你轻松搭出有型又实穿的秋冬造型。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20autumn%20street%20style%20scene%20with%20warm%20knitwear%20and%20coat%2C%20soft%20golden%20light%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition&width=800&height=600&seq=chigua-fashion-02-cover&orientation=landscape",
    category: "fashion",
    categoryName: "时尚穿搭",
    type: "report",
    tags: ["明星街拍", "秋冬穿搭", "单品"],
    author: "穿搭研究所",
    publishTime: "2026-10-03T10:10:00+08:00",
    views: 62100,
    likes: 4780,
    content: [
      "秋冬换季，明星们的街拍再次成为大众获取穿搭灵感的重要来源。相比红毯上的隆重造型，街拍中的搭配显然更加日常也更好借鉴。",
      "本季出镜率最高的几件单品包括oversize羽绒服、暖色调针织衫以及复古感的阔腿裤。它们共同的特点是保暖实穿，同时又能轻松营造层次感。",
      "配色方面，大地色系依旧是绝对主流，驼色、焦糖色与浅棕色的组合既温暖又高级，非常适合秋冬季节的氛围。",
      "想要穿出明星同款的效果，关键并不在于价格，而在于比例与整体的协调。选对适合自己身形的版型，才是最实用的穿搭技巧。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=autumn%20outfit%20flat%20lay%20with%20warm%20knitwear%20scarf%20and%20leather%20bag%2C%20soft%20natural%20light%2C%20cozy%20neutral%20tones%2C%20editorial%20fashion%20photography%2C%20clean%20composition&width=1200&height=800&seq=chigua-fashion-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=stylish%20autumn%20street%20scene%20with%20warm%20cafe%20storefront%2C%20soft%20golden%20light%2C%20cozy%20urban%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20tones&width=1200&height=800&seq=chigua-fashion-02-gal2&orientation=landscape",
    ],
  },
  {
    id: "gossip-01",
    title: "圈内人爆料某剧组内幕，知情者还原事件经过",
    summary:
      "一则关于某剧组的爆料在网络上流传，引发广泛讨论。多位自称知情者先后发声，从不同角度还原了事件的经过，真相仍待厘清。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20film%20set%20at%20dusk%20with%20warm%20orange%20lights%2C%20silhouettes%20and%20equipment%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=600&seq=chigua-gossip-01-cover&orientation=landscape",
    category: "gossip",
    categoryName: "八卦爆料",
    type: "report",
    tags: ["圈内爆料", "剧组", "知情人"],
    author: "吃瓜小分队",
    publishTime: "2026-10-08T14:25:00+08:00",
    views: 165300,
    likes: 10240,
    content: [
      "近日，一则围绕某剧组的爆料在网络流传，内容涉及拍摄期间的种种细节，迅速吸引大量网友围观，相关话题热度居高不下。",
      "随着讨论升温，多位自称知情者的网友先后发声，从不同角度描述了自己了解的情况。不过，各方说法之间存在明显出入，事件全貌仍有待厘清。",
      "截至目前，剧组方面尚未就爆料内容作出正式回应。业内人士提醒，网络信息真伪难辨，在官方说明出现之前，不宜过早下结论。",
      "对于吃瓜群众而言，保持理性或许才是最重要的。娱乐新闻固然有趣，但在事实尚未明确时，克制传播未经证实的信息同样是一种善意。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=backstage%20film%20set%20with%20director%20chair%20and%20warm%20directional%20lighting%2C%20cinematic%20moody%20atmosphere%2C%20documentary%20photography%2C%20soft%20shadows&width=1200&height=800&seq=chigua-gossip-01-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=stack%20of%20movie%20scripts%20and%20notebooks%20on%20a%20warm%20lit%20desk%2C%20soft%20shadows%2C%20editorial%20still%20life%2C%20warm%20neutral%20tones%2C%20clean%20composition&width=1200&height=800&seq=chigua-gossip-01-gal2&orientation=landscape",
    ],
  },
  {
    id: "gossip-02",
    title: "多年好友疑似关系生变，双方社交平台互动清零",
    summary:
      "两位相识多年的艺人被网友发现社交平台互动突然清零，引发关系生变的猜测。截至目前，双方均未对此作出任何回应。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20empty%20chairs%20side%20by%20side%20in%20a%20warm%20lit%20room%2C%20soft%20dramatic%20light%2C%20symbolic%20moody%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=600&seq=chigua-gossip-02-cover&orientation=landscape",
    category: "gossip",
    categoryName: "八卦爆料",
    type: "news",
    tags: ["关系解读", "猜测", "互动"],
    author: "娱记阿柴",
    publishTime: "2026-10-02T19:00:00+08:00",
    views: 88900,
    likes: 5990,
    content: [
      "有细心的网友发现，两位相识多年的艺人在社交平台上的互动近期突然清零，过去的合影与留言也陆续不见踪影，随即引发关系生变的猜测。",
      "消息传开后，各种解读层出不穷。有人认为只是正常的整理账号，也有人联想到此前的一些细节，一时间众说纷纭。",
      "值得注意的是，截至目前，双方及其团队均未对此作出任何回应，也没有任何官方渠道证实所谓的关系变化。",
      "娱乐圈的人际关系向来复杂，外界看到的往往只是冰山一角。与其过度解读，不如把这份好奇心留给作品本身。",
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=smartphone%20with%20social%20media%20app%20open%20on%20a%20warm%20lit%20table%2C%20soft%20shadows%2C%20editorial%20technology%20photography%2C%20clean%20composition&width=1200&height=800&seq=chigua-gossip-02-gal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20cozy%20cafe%20table%20with%20two%20coffee%20cups%20in%20warm%20light%2C%20soft%20bokeh%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=chigua-gossip-02-gal2&orientation=landscape",
    ],
  },
];

export interface HotKeyword {
  word: string;
}

export const hotKeywords: string[] = [
  "顶流恋情",
  "科幻大片口碑",
  "直播带货纪录",
  "红毯造型",
  "颁奖礼",
  "新专辑",
  "演唱会门票",
  "秋冬穿搭",
  "剧组爆料",
];